import { put, takeLatest, call } from 'redux-saga/effects';
import Api from 'guardian/reducers/Api';

// Action Types
const FETCH_ACCOUNTS = 'guardian/accounts/FETCH_ACCOUNTS';
const FETCH_ACCOUNTS_SUCCESS = 'guardian/accounts/FETCH_ACCOUNTS_SUCCESS';
const FETCH_ACCOUNTS_FAILURE = 'guardian/accounts/FETCH_ACCOUNTS_FAILURE';
const FETCH_ACCOUNT = 'guardian/accounts/FETCH_ACCOUNT';
const FETCH_ACCOUNT_SUCCESS = 'guardian/accounts/FETCH_ACCOUNT_SUCCESS';
const CREATE_ACCOUNT = 'guardian/accounts/CREATE_ACCOUNT';
const CREATE_ACCOUNT_SUCCESS = 'guardian/accounts/CREATE_ACCOUNT_SUCCESS';
const UPDATE_ACCOUNT = 'guardian/accounts/UPDATE_ACCOUNT';
const UPDATE_ACCOUNT_SUCCESS = 'guardian/accounts/UPDATE_ACCOUNT_SUCCESS';
const DELETE_ACCOUNT = 'guardian/accounts/DELETE_ACCOUNT';
const DELETE_ACCOUNT_SUCCESS = 'guardian/accounts/DELETE_ACCOUNT_SUCCESS';
const SET_ERROR = 'guardian/accounts/SET_ERROR';

// Action Creators
export const actions = {
  fetchAccounts: () => ({ type: FETCH_ACCOUNTS }),
  fetchAccount: (id) => ({ type: FETCH_ACCOUNT, payload: id }),
  createAccount: (data, callback) => ({ type: CREATE_ACCOUNT, payload: { data, callback } }),
  updateAccount: (id, data, callback) => ({ type: UPDATE_ACCOUNT, payload: { id, data, callback } }),
  deleteAccount: (id, callback) => ({ type: DELETE_ACCOUNT, payload: { id, callback } }),
};

// Initial State
const initialState = {
  list: [],
  count: 0,
  current: null,
  loading: false,
  error: null,
};

// Reducer
export default function accountsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACCOUNTS:
    case FETCH_ACCOUNT:
      return { ...state, loading: true, error: null };
    case FETCH_ACCOUNTS_SUCCESS:
      return { ...state, loading: false, list: action.payload.results, count: action.payload.count };
    case FETCH_ACCOUNT_SUCCESS:
      return { ...state, loading: false, current: action.payload };
    case CREATE_ACCOUNT_SUCCESS:
      return { ...state, list: [...state.list, action.payload] };
    case UPDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        current: action.payload,
        list: state.list.map((a) => (a.id === action.payload.id ? action.payload : a)),
      };
    case DELETE_ACCOUNT_SUCCESS:
      return { ...state, list: state.list.filter((a) => a.id !== action.payload) };
    case FETCH_ACCOUNTS_FAILURE:
    case SET_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

// Sagas
function* fetchAccountsSaga() {
  try {
    const response = yield call(Api.fetchAccounts);
    yield put({ type: FETCH_ACCOUNTS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: FETCH_ACCOUNTS_FAILURE, payload: error.message });
  }
}

function* fetchAccountSaga(action) {
  try {
    const response = yield call(Api.fetchAccount, action.payload);
    yield put({ type: FETCH_ACCOUNT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: SET_ERROR, payload: error.message });
  }
}

function* createAccountSaga(action) {
  try {
    const response = yield call(Api.createAccount, action.payload.data);
    yield put({ type: CREATE_ACCOUNT_SUCCESS, payload: response.data });
    if (action.payload.callback) action.payload.callback(response.data);
  } catch (error) {
    yield put({ type: SET_ERROR, payload: error.message });
  }
}

function* updateAccountSaga(action) {
  try {
    const response = yield call(Api.updateAccount, action.payload.id, action.payload.data);
    yield put({ type: UPDATE_ACCOUNT_SUCCESS, payload: response.data });
    if (action.payload.callback) action.payload.callback(response.data);
  } catch (error) {
    yield put({ type: SET_ERROR, payload: error.message });
  }
}

function* deleteAccountSaga(action) {
  try {
    yield call(Api.deleteAccount, action.payload.id);
    yield put({ type: DELETE_ACCOUNT_SUCCESS, payload: action.payload.id });
    if (action.payload.callback) action.payload.callback();
  } catch (error) {
    yield put({ type: SET_ERROR, payload: error.message });
  }
}

export function* accountsSagas() {
  yield takeLatest(FETCH_ACCOUNTS, fetchAccountsSaga);
  yield takeLatest(FETCH_ACCOUNT, fetchAccountSaga);
  yield takeLatest(CREATE_ACCOUNT, createAccountSaga);
  yield takeLatest(UPDATE_ACCOUNT, updateAccountSaga);
  yield takeLatest(DELETE_ACCOUNT, deleteAccountSaga);
}
